import { useLocation } from 'react-router-dom';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';

import MealRoute from './MealRoute';
import GroupOfFinishedProductRoute from './GroupOfFinishedProductRoute';

const Meals = props => {
  const { pathname } = useLocation();
  const isKwg = pathname.includes('kwg-groups');

  return (
    <DataGridStateContextProvider>
      {isKwg ? (
        <GroupOfFinishedProductRoute props={props} />
      ) : (
        <MealRoute props={props} />
      )}
    </DataGridStateContextProvider>
  );
};

export default Meals;
